<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
    >
      <template v-slot:orgId>
        <el-select
          multiple
          filterable
          v-model="filters.orgId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in organizations"
            :label="item.customName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.warehouseId"
          placeholder="请选择"
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template v-slot:boxStatus>
        <el-select multiple v-model="filters.boxStatus" placeholder="请选择">
          <el-option
            v-for="item in boxStatusList"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
       <template slot-scope="scope" slot="op_KeName">
        <div
          v-if="scope.row.oP_KeName != null && scope.row.oP_KeName != ''"
        >
          <div
            v-for="(item, index) in scope.row.oP_KeName.split(',')"
            :key="index"
          >
         {{ item }}
          </div>
        </div>
      </template>

    </TwTable>
    <el-dialog
      id="completeDialog"
      title="备货任务"
      :visible.sync="addTaskdialogVisible"
      width="60%"
      style="text-align: center"
       
    >
      <div id="completeDiv">
        <iframe
          :src="completeTask"
          height="600"
          width="100%"
          style="border: none"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInventoryBatchBoxStatus,
  getInventoryBatchBoxGauge,
  inventoryBatchBoxGaugeExport,
} from "@/api/report/inventoryList.js";
import {
  addCachingBatchBox,
} from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { getCustomerList } from "@/api/ProductSku.js";
import axios from "axios";
import { thereAre } from "util/util";
export default {
  components: { TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          // 表格操作配置
        },
        column: [
          // 表格列配置
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "locationCode",
            label: "库位",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "boxMark",
            label: "箱号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "batchCode",
            label: "批次号",
            align: "center",
            minWidth: "150",
            sortable: true,
          },
          {
            prop: "boxStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "createTime",
            label: "入库时间    ",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "outStockTime",
            label: "出库时间",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "remark",
            label: "箱规",
            align: "center",
            minWidth: "200",
            formatter: function (val, row) {
              return row.boxLength + "*" + row.boxWidth + "*" + row.boxHeight;
            },
          },
          {
            prop: "boxSingleCount",
            label: "PSC数",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
           {
            prop: "op_KeName",
            label: "SKU",
        
            slot: true,
            minWidth: "180",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "orgId",
            prop: "orgId",
            label: "客户",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.organizations,
          },
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            type: "input",
            key: "boxMark",
            label: "箱号",
            placeholder: "多个箱号用逗号分开查询",
            clearable: true,
          },
          {
            type: "input",
            key: "batchCode",
            label: "批次号",
            placeholder: "多个批次号用逗号分开查询",
            clearable: true,
          },

          {
            type: "select",
            key: "boxStatus",
            prop: "boxStatus",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.boxStatusList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "入库时间",
          },
        ],
      },
      buttonList: [],

      //-------------
      organizations: [],
      warehouses: [],
      boxStatusList: [],
      addTaskdialogVisible: false,
      completeTask: "",
    };
  },
   created() {
    // 监听子组件的关闭事件
    window.addEventListener('message', () => {
       this.closeSelf();
    }, false);
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
   closeSelf() { // 关闭当前弹框
       this.addTaskdialogVisible = false;
       this.initTable();
    },
    // 弹出添加任务
    addTaskdialog() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "至少选择一行数据！",
          type: "error",
        });
        return;
      }
      let wareHouseId = row[0].warehouseID;
      let orgId = row[0].orgID;
     
      
      let wareHouseArr = row.filter((m) => {
        return m.warehouseID === wareHouseId;
      });
      
      if (row.length != wareHouseArr.length) {
        this.$message({
          message: "请选择同一仓库箱号",
          type: "error",
        });
        return;
      }
      let orgArr = row.filter((m) => {
        return m.orgID === orgId;
      });
      if (row.length != orgArr.length) {
        this.$message({
          message: "请选择同一客户箱号",
          type: "error",
        });
        return;
      }
    
      let boxStatusArr = row.filter((m) => {
        return m.boxStatus !== 10;
      });
      if (boxStatusArr.length > 0) {
        this.$message({
          message: "请选择状态是【在库】的箱号",
          type: "error",
        });
        return;
      }
     
      let pata = {
        warehouseId: wareHouseId,
        orgID: orgId,
        inventoryBatchBoxGaugeID: row.map(
          (item) => item.inventoryBatchBoxGaugeID
        ),
      };
     
     
      addCachingBatchBox(pata).then((res) => {
        if (res.data.success) {
          var random= Math.random();
          this.completeTask = "/Outbound/AddReadyforTask?random="+random+"&warehouseId="+wareHouseId+"&orgID="+orgId;
          this.addTaskdialogVisible = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
      //var random= Math.random();
    },
    //查询列表
    initTable() {
      const { orgId, warehouseId, boxMark, batchCode, boxStatus, tdate } =
        this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        orgId: thereAre(orgId),
        warehouseId: thereAre(warehouseId),
        boxMark,
        batchCode,
        boxStatus: thereAre(boxStatus),
      };
      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getInventoryBatchBoxGauge(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let inventoryBatchBoxGaugeIDs = "";
      row.forEach((item) => {
        inventoryBatchBoxGaugeIDs += item.inventoryBatchBoxGaugeID + ",";
      });

      const { orgId, warehouseId, boxMark, batchCode, boxStatus, tdate } =
        this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        orgId: thereAre(orgId),
        warehouseId: thereAre(warehouseId),
        boxMark,
        batchCode,
        boxStatus: thereAre(boxStatus),
        inventoryBatchBoxGaugeIDList: thereAre(inventoryBatchBoxGaugeIDs),
      };

      if (tdate != null && tdate != "null") {
        pata.startdate = tdate[0];
        pata.enddate = tdate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: inventoryBatchBoxGaugeExport,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    let para = {
      IsAll: true,
    };
    getCustomerList(para).then((res) => {
      this.organizations = res.data.response;
    });
    getInventoryBatchBoxStatus("").then((res) => {
      this.boxStatusList = res.data.response;
    });
  },
};
</script>